var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "35",
        height: "35",
        version: "1.1",
        viewBox: "0 0 63.584 60.055",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { transform: "translate(-44.904 -28.945)" } }, [
        _c("path", {
          staticStyle: { "paint-order": "fill markers stroke" },
          attrs: {
            d:
              "m102.05 59.631a27.781 27.781 0 0 1-27.671 27.781 27.781 27.781 0 0 1-27.891-27.561 27.781 27.781 0 0 1 27.45-28",
            fill: "none",
            stroke: "currentColor",
            "stroke-dasharray": "19.05, 6.35",
            "stroke-dashoffset": "19.368",
            "stroke-linecap": "round",
            "stroke-opacity": ".94118",
            "stroke-width": "3.175"
          }
        }),
        _vm._v(" "),
        _c(
          "text",
          {
            staticStyle: { "line-height": "1.25" },
            attrs: {
              x: "75.034111",
              y: "69.026497",
              fill: "currentColor",
              "font-family": "sans-serif",
              "font-size": "19.756px",
              "letter-spacing": "0px",
              "stroke-width": ".26458",
              "text-align": "center",
              "text-anchor": "middle",
              "word-spacing": "0px",
              "xml:space": "preserve"
            }
          },
          [
            _c(
              "tspan",
              {
                attrs: {
                  x: "75.034111",
                  y: "69.026497",
                  "stroke-width": ".26458"
                }
              },
              [
                _c(
                  "tspan",
                  {
                    attrs: {
                      x: "75.034111",
                      y: "69.026497",
                      "font-size": "22.578px",
                      "stroke-width": ".26458",
                      "text-align": "center",
                      "text-anchor": "middle"
                    }
                  },
                  [_vm._v("45°")]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("path", {
          staticStyle: { "paint-order": "fill markers stroke" },
          attrs: {
            d: "m93.835 52.78 7.7588 9.1024 6.8934-9.2465",
            "stroke-width": "0",
            fill: "currentColor",
            stroke: "currentColor"
          }
        }),
        _vm._v(" "),
        _c("path", {
          staticStyle: { "paint-order": "fill markers stroke" },
          attrs: {
            transform: "rotate(268.32)",
            d: "m-34.323 75.807a24.077 24.077 0 0 1-21.412 23.929",
            fill: "none",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-width": "6.2581"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }